"use client";

const DIGITS = "0123456789";

/**
 * "$200,000" with every digit on its own 0–9 reel that rolls to the new value (the WCE prize-pool
 * counter). Each reel is as wide as its current digit, so at rest the text keeps Geist's own
 * spacing. Reels are keyed from the right, so existing ones roll and new ones slide in on the left.
 * Line height is Geist's "normal" (1.3), which is also the reel step.
 */
export default function RollingNumber({ value, className }: { value: number; className?: string }) {
  return <RollingDigits text={`$${Math.round(value).toLocaleString("en-US")}`} className={className} />;
}

/** Any text, with every digit on its own reel (e.g. a countdown's "07"). */
export function RollingDigits({ text, className }: { text: string; className?: string }) {
  const chars = text.split("");
  return (
    <span className={className} style={{ display: "inline-flex", lineHeight: 1.3 }} aria-label={chars.join("")}>
      {chars.map((ch, i) => {
        const key = chars.length - i;
        if (!DIGITS.includes(ch)) {
          return (
            <span key={`s${key}`} aria-hidden="true" style={{ fontFamily: "inherit" }}>
              {ch}
            </span>
          );
        }
        const d = Number(ch);
        return (
          <span key={`d${key}`} aria-hidden="true" className="relative inline-block overflow-hidden" style={{ height: "1.3em", fontFamily: "inherit" }}>
            {/* sizes the reel to the digit it shows */}
            <span className="invisible" style={{ fontFamily: "inherit" }}>
              {ch}
            </span>
            <span
              className="absolute top-0 left-1/2 flex -translate-x-1/2 flex-col items-center transition-transform duration-700 ease-[cubic-bezier(0.22,0.61,0.36,1)] motion-reduce:transition-none"
              style={{ transform: `translate(-50%, ${-d * 1.3}em)`, fontFamily: "inherit" }}>
              {DIGITS.split("").map((n) => (
                <span key={n} className="block" style={{ height: "1.3em", fontFamily: "inherit" }}>
                  {n}
                </span>
              ))}
            </span>
          </span>
        );
      })}
    </span>
  );
}
